import mixitup from 'mixitup';

export default class PostFilter {

    static init() {
        const els = document.querySelectorAll('[data-mixitup]');

        els.forEach((el) => new this(el));
    }

    constructor(el) {
        this.el = el;

        this.mixer = mixitup(this.el, {
            animation: {

            },
            selectors: {
                target: '[data-mixitup-card]'
            },
        });
    }
}